import i18n from "i18next";
import { toast } from "react-toastify";

export const toastError = (message?: string) => {
  toast.error(i18n.t(message ?? "errors.error_append", { ns: "common" }));
};
